import React, { Component, Fragment } from 'react';
import Backtotop from './Backtotop';
import social2 from '../../configs/social2.json';
import NewsLetter from "./NewsLetter";

class Footer extends Component {
    render() {
        return (
            <Fragment>
                <Backtotop />
                <footer>
                    <NewsLetter/>
                    <div className="copyright-area pt-20 pb-20">
                        <div className="container">
                            <div className="row align-items-center">
                                <div className="col-md-5 order-2 order-md-1">
                                    <p className="copyright-text">copyright by@<a href="https://www.maffle.it" target="_blank">Maffle</a></p>
                                </div>
                                <div className="col-md-7 order-1 order-md-2">
                                    <div className="social-links">

                                        {social2.map((social,index)=>
                                            <a href={social.link} target="_blank"><i className={social.icon} /></a>
                                        )}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </Fragment>
        );
    }
}

export default Footer;